// 2-row × 3-col grid of supported candle intervals. Match bb-traderx wizard's chunky
// `rounded-xl border-2` button with stacked label + subtitle.

import { cn } from "@/lib/utils";
import type { CandleInterval } from "../../../api/types";

const INTERVALS: { value: CandleInterval; subtitle: string }[] = [
  { value: "1m", subtitle: "Scalp" },
  { value: "5m", subtitle: "Scalp" },
  { value: "15m", subtitle: "Intraday" },
  { value: "1h", subtitle: "Intraday" },
  { value: "4h", subtitle: "Swing" },
  { value: "1d", subtitle: "Position" },
];

interface Props {
  value: CandleInterval;
  onChange: (v: CandleInterval) => void;
}

export function TimeframeGrid({ value, onChange }: Props) {
  return (
    <div className="grid grid-cols-3 sm:grid-cols-6 gap-2">
      {INTERVALS.map((tf) => {
        const active = tf.value === value;
        return (
          <button
            key={tf.value}
            type="button"
            onClick={() => onChange(tf.value)}
            className={cn(
              "flex flex-col items-center gap-1 py-2 px-1 rounded-xl border-2 transition-all cursor-pointer",
              active
                ? "border-primary bg-primary/10"
                : "border-border bg-card-elevated hover:border-primary/50",
            )}
          >
            <span
              className={cn(
                "text-sm font-bold font-mono",
                active ? "text-primary" : "text-foreground",
              )}
            >
              {tf.value}
            </span>
            <span className="text-[10px] text-muted-foreground">{tf.subtitle}</span>
          </button>
        );
      })}
    </div>
  );
}
